export enum UserRoles {
  User = "User",
  Admin = "Administrator",
  SuperAdmin = "SuperAdmin",
  Supervisor = "Supervisor",
  Accountant = "Accountant",
  CustomerServices = "Customer Services",
}
